import React from 'react';
import ContainerValidation from './Components/ContainerValidation';
import HeaderValidation from './Components/HeaderValidation';
import BodyValidation from './Components/BodyValidation';
import routes from '../../../../Routes/routes';
import CreateValidationApp from './Functionality/CreateValidationApp';
import StepContainer from './Steps/StepContainer';
import {getUrlParameters, TAB_INDEX} from './Model/Model';
import CustomDescriptionLabel from '../../../../components/CustomDescriptionLabel';
import GenericModal from '../../../Modals/GenericModal';
import useForbiddenValidation from './Functionality/useForbiddenValidation';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const CreateValidation = () => {

    const {
        guardFlowId,
        type,
        t, navigate,
        loading,
        btnDisabled,
        getInvitationById,
        steps, setSteps,
        activeStep, setActiveStep,
        passport, setPassport,
        idCardBack, setIdCardBack,
        idCardFront, setIdCardFront,
        facePhoto, setFacePhoto,
        nextPhoto, setNextPhoto,
        startup, setStartup,
        reopenSuggestionShow, setReopenSuggestionShow,

        handleClickNext,
        handleSavePassport,
        handleSaveCardId,
        handleSaveFaceValidation,

        handleCancelStreamCardId,
        handleCancelStreamPassport,
        handleCancelStreamSelfie,
        showModalCancelPicker,
        confirmModalPicker,
        cancelModalPicker,
        handleNavigateBack
    } = CreateValidationApp();

    useForbiddenValidation({getInvitationById})
    return (<>
        <>
            <ContainerValidation>
            <HeaderValidation
                activeStep={activeStep}
                steps={steps?.TOTAL}
                click={()=>{
                    handleNavigateBack()
                }}
                showBtnBack={activeStep != TAB_INDEX.THREE}
                headerCenter={
                    <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center align-self-center gap-1">
                        <p className="fs-16-to-14 ibl-font-w-600 font-color-general-950 text-center">{t("identity_validation_title")}</p>
                        <p className="fs-16-to-14 ibl-font-w-600 font-color-general-950 d-none d-sm-block">{"•"}</p>
                        <p className="fs-16-to-12 ibl-font-w-400 font-color-general-950 text-center">{`${t("step")} ${activeStep} ${t("of")} ${steps?.TOTAL - 1} `}</p>
                    </div>
                }
            />

            <BodyValidation
                textFooter={activeStep == TAB_INDEX.TWO ? "choose_a_different_document" : ""}
                click={() => {
                    handleClickNext();
                }}
                btnDisabled={btnDisabled}
                clickHref={()=>{
                    navigate(getUrlParameters({ url: routes.invitationDetails.chooseValidationType, id: getInvitationById?.invitation?.id, guardFlowId}))
                }}
            >
                <div className="w-100">
                    { steps && (
                        <StepContainer
                            guardFlowId={guardFlowId}
                            stepModel={steps}
                            activeStep={activeStep}
                            setActiveStep={setActiveStep}

                            facePhoto={facePhoto}
                            setFacePhoto={setFacePhoto}
                            passport={passport}
                            setPassport={setPassport}
                            idCardBack={idCardBack}
                            setIdCardBack={setIdCardBack}
                            idCardFront={idCardFront}
                            setIdCardFront={setIdCardFront}

                            t={t}
                            type={type}
                            loading={loading}
                            nextPhoto={nextPhoto}

                            startup={startup}
                            setStartup={setStartup}
                            reopenSuggestionShow={reopenSuggestionShow}
                            setReopenSuggestionShow={setReopenSuggestionShow}

                            handleSavePassport={handleSavePassport}
                            handleSaveCardId={handleSaveCardId}
                            handleSaveFaceValidation={handleSaveFaceValidation}
                            handleCancelStreamCardId={handleCancelStreamCardId}
                            handleCancelStreamPassport={handleCancelStreamPassport}
                            handleCancelStreamSelfie={handleCancelStreamSelfie}
                        />
                    )}
                </div>
            </BodyValidation>
        </ContainerValidation>

            {showModalCancelPicker &&
                <GenericModal
                    title={t('cancel_camera')}
                    show={ showModalCancelPicker }
                    onHide={()=>{
                        cancelModalPicker();
                    }}
                    onConfirm={()=>{
                        confirmModalPicker();
                    }}
                >
                    <div className={"col-12"}>
                        <CustomDescriptionLabel trans={t('are_you_sure_you_want_to_close_the_camera_you_will_lose_all_your_progress')} bold={"normal"}/>
                    </div>
                </GenericModal>
            }
        </>
    </>)
}

export default CreateValidation
